(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-bienvenida"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tp-bienvenida')) {
    const CLAVE = 'tp_bienvenida';

    const leer = () => {
      try {
        return localStorage.getItem(CLAVE);
      } catch (e) {
        return null;
      }
    };

    const guardar = (valor) => {
      try {
        localStorage.setItem(CLAVE, valor);
      } catch (e) {}
    };

    class TpBienvenida extends HTMLElement {
      connectedCallback() {
        this.dialogo = this.querySelector('dialog');
        if (!this.dialogo) return;

        this.querySelectorAll('[data-cerrar]').forEach((boton) =>
          boton.addEventListener('click', () => this.cerrar())
        );
        // Clic fuera de la caja (en el fondo) y tecla Esc
        this.dialogo.addEventListener('click', (evento) => {
          if (evento.target === this.dialogo) this.cerrar();
        });
        this.dialogo.addEventListener('cancel', (evento) => {
          evento.preventDefault();
          this.cerrar();
        });
        this.dialogo.addEventListener('close', () => {
          document.documentElement.classList.remove('tp-bienvenida-abierta');
        });

        const copiar = this.querySelector('[data-copiar]');
        if (copiar) {
          copiar.addEventListener('click', () => {
            const listo = () => {
              copiar.textContent = copiar.dataset.copiado || 'Copiado';
            };
            if (navigator.clipboard) navigator.clipboard.writeText(this.dataset.codigo).then(listo, () => {});
          });
        }

        if (this.hasAttribute('data-editor')) {
          this.enEditor();
          return;
        }

        // Regresa de suscribirse: muestra el código y lo deja aplicado
        if (this.querySelector('[data-exito]')) {
          guardar('suscrito');
          this.aplicar();
          this.abrir(true);
          this.limpiarDireccion();
          return;
        }
        // Regresa con error (p. ej. correo mal escrito): vuelve a abrir
        if (this.querySelector('[data-error]')) {
          this.abrir(true);
          this.limpiarDireccion();
          return;
        }

        const estado = leer();
        if (estado === 'suscrito') return;
        const dias = Number(this.dataset.dias) || 7;
        if (estado && Date.now() - Number(estado) < dias * 864e5) return;

        const retraso = Math.max(0, Number(this.dataset.retraso) || 0) * 1000;
        this.temporizador = setTimeout(() => this.abrir(), retraso);
        this.alBajar = () => {
          const total = document.documentElement.scrollHeight - window.innerHeight;
          if (total > 0 && window.scrollY > total * 0.5) this.abrir();
        };
        window.addEventListener('scroll', this.alBajar, { passive: true });
      }

      disconnectedCallback() {
        clearTimeout(this.temporizador);
        if (this.alBajar) window.removeEventListener('scroll', this.alBajar);
      }

      abrir(forzar = false) {
        if (!this.dialogo || this.dialogo.open) return;
        clearTimeout(this.temporizador);
        if (this.alBajar) window.removeEventListener('scroll', this.alBajar);
        // No encima del carrito u otra ventana abierta: espera a que la cierren
        if (!forzar && document.querySelector('dialog[open]')) {
          this.temporizador = setTimeout(() => this.abrir(), 4000);
          return;
        }
        this.dialogo.showModal();
        document.documentElement.classList.add('tp-bienvenida-abierta');
      }

      cerrar(recordar = true) {
        if (this.dialogo && this.dialogo.open) this.dialogo.close();
        document.documentElement.classList.remove('tp-bienvenida-abierta');
        if (recordar && !this.hasAttribute('data-editor') && leer() !== 'suscrito') guardar(String(Date.now()));
      }

      async aplicar() {
        const codigo = this.dataset.codigo;
        if (!codigo) return;
        try {
          // Para el pago (cookie) y para que se vea en el carrito
          await fetch(`/discount/${encodeURIComponent(codigo)}?redirect=${encodeURIComponent('/cart.js')}`, {
            credentials: 'same-origin',
          });
          const carrito = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
          const codigos = (carrito.discount_codes || []).map((d) => d.code);
          if (!codigos.some((c) => c.toLowerCase() === codigo.toLowerCase())) codigos.push(codigo);
          await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codigos.join(',') }),
          });
        } catch (e) {}
      }

      limpiarDireccion() {
        try {
          const url = new URL(window.location.href);
          if (!url.searchParams.has('customer_posted') && !url.hash) return;
          url.searchParams.delete('customer_posted');
          url.hash = '';
          history.replaceState(history.state, '', url.toString());
        } catch (e) {}
      }

      enEditor() {
        const seccion = this.closest('.shopify-section');
        const esEsta = (evento) => seccion && evento.detail && seccion.id.endsWith(evento.detail.sectionId);
        document.addEventListener('shopify:section:select', (evento) => {
          if (esEsta(evento)) this.abrir(true);
        });
        document.addEventListener('shopify:section:deselect', (evento) => {
          if (esEsta(evento)) this.cerrar(false);
        });
      }
    }

    customElements.define('tp-bienvenida', TpBienvenida);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-colecciones"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tp-colecciones')) {
    class TpColecciones extends HTMLElement {
      connectedCallback() {
        const lista = this.querySelector('.tp-colecciones__lista');
        const activa = this.querySelector('.tp-colecciones__enlace--activa');
        if (!lista || !activa || lista.scrollWidth <= lista.clientWidth) return;
        const item = activa.parentElement;
        lista.scrollLeft = item.offsetLeft - (lista.clientWidth - item.offsetWidth) / 2;
      }
    }
    customElements.define('tp-colecciones', TpColecciones);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-pestanas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tp-pestanas')) {
    class TpPestanas extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.activar(tab));
          tab.addEventListener('keydown', (e) => {
            const siguiente = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -1;
            if (siguiente < 0 || siguiente >= this.tabs.length) return;
            e.preventDefault();
            this.activar(this.tabs[siguiente], true);
          });
        });
        this.alElegirBloque = (e) => {
          const tab = this.tabs.find((t) => t === e.target || t.contains(e.target));
          if (tab) this.activar(tab);
        };
        document.addEventListener('shopify:block:select', this.alElegirBloque);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.alElegirBloque);
      }

      activar(tab, conFoco = false) {
        this.tabs.forEach((t) => {
          const activo = t === tab;
          t.setAttribute('aria-selected', String(activo));
          t.tabIndex = activo ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          if (activo) {
            const diferido = panel.querySelector(':scope > template.tp-pestanas__diferido');
            if (diferido) panel.replaceChildren(document.importNode(diferido.content, true));
          }
          panel.hidden = !activo;
        });
        if (conFoco) tab.focus();
        const lista = tab.parentElement;
        if (lista && lista.scrollWidth > lista.clientWidth) {
          const destino = tab.offsetLeft - (lista.clientWidth - tab.offsetWidth) / 2;
          lista.scrollTo({ left: destino, behavior: 'smooth' });
        }
      }
    }
    customElements.define('tp-pestanas', TpPestanas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-portada"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tp-portada')) {
    class TpPortada extends HTMLElement {
      connectedCallback() {
        this.diapos = Array.from(this.querySelectorAll('.tp-portada__diapo'));
        this.barras = Array.from(this.querySelectorAll('.tp-portada__barra'));
        this.pausas = new Set();
        this.actual = Math.max(
          0,
          this.diapos.findIndex((diapo) => diapo.classList.contains('is-activa'))
        );
        if (this.diapos.length < 2) return;

        this.barras.forEach((barra, i) => barra.addEventListener('click', () => this.ir(i)));
        this.addEventListener('animationend', this.alTerminar);
        this.addEventListener('pointerenter', this.alEntrar);
        this.addEventListener('pointerleave', this.alSalir);
        this.addEventListener('focusin', this.alEnfocar);
        this.addEventListener('focusout', this.alDesenfocar);
        this.addEventListener('touchstart', this.alTocar, { passive: true });
        this.addEventListener('touchend', this.alSoltar, { passive: true });
        this.addEventListener('touchcancel', this.alSoltar, { passive: true });
        document.addEventListener('visibilitychange', this.alCambiarVista);
        document.addEventListener('shopify:block:select', this.alElegirBloque);
        document.addEventListener('shopify:block:deselect', this.alSoltarBloque);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.alCambiarVista);
        document.removeEventListener('shopify:block:select', this.alElegirBloque);
        document.removeEventListener('shopify:block:deselect', this.alSoltarBloque);
      }

      pausar(motivo, activa) {
        if (activa) this.pausas.add(motivo);
        else this.pausas.delete(motivo);
        this.toggleAttribute('data-pausa', this.pausas.size > 0);
      }

      ir(indice) {
        const total = this.diapos.length;
        const i = ((indice % total) + total) % total;
        this.diapos.forEach((diapo, j) => {
          const activa = j === i;
          diapo.classList.toggle('is-activa', activa);
          diapo.toggleAttribute('inert', !activa);
          diapo.setAttribute('aria-hidden', activa ? 'false' : 'true');
        });
        this.barras.forEach((barra, j) => {
          barra.classList.toggle('is-vista', j < i);
          if (j === i) barra.setAttribute('aria-current', 'true');
          else barra.removeAttribute('aria-current');
        });
        this.actual = i;
      }

      alTerminar = (evento) => {
        if (evento.animationName !== 'tp-portada-llenar') return;
        if (evento.target.closest('.tp-portada__barra') !== this.barras[this.actual]) return;
        this.ir(this.actual + 1);
      };

      alEntrar = (evento) => {
        if (evento.pointerType === 'mouse') this.pausar('raton', true);
      };

      alSalir = (evento) => {
        if (evento.pointerType === 'mouse') this.pausar('raton', false);
      };

      alEnfocar = (evento) => {
        if (evento.target instanceof Element && evento.target.matches(':focus-visible')) this.pausar('foco', true);
      };

      alDesenfocar = (evento) => {
        if (!this.contains(evento.relatedTarget)) this.pausar('foco', false);
      };

      alTocar = (evento) => {
        const toque = evento.touches[0];
        this.x0 = toque.clientX;
        this.y0 = toque.clientY;
        this.pausar('dedo', true);
      };

      alSoltar = (evento) => {
        this.pausar('dedo', false);
        const toque = evento.changedTouches && evento.changedTouches[0];
        if (!toque || this.x0 == null) return;
        const dx = toque.clientX - this.x0;
        const dy = toque.clientY - this.y0;
        this.x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) this.ir(this.actual + (dx < 0 ? 1 : -1));
      };

      alCambiarVista = () => this.pausar('oculta', document.hidden);

      alElegirBloque = (evento) => {
        const i = this.diapos.findIndex((diapo) => diapo === evento.target || diapo.contains(evento.target));
        if (i < 0) return;
        this.ir(i);
        this.pausar('editor', true);
      };

      alSoltarBloque = (evento) => {
        if (this.contains(evento.target)) this.pausar('editor', false);
      };
    }

    customElements.define('tp-portada', TpPortada);
  }

  } catch(e) { console.error(e); }
})();
})();
